var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"all"}},[_c('div',{attrs:{"id":"all_div"}},[_c('p',{staticClass:"all_p0"},[_vm._v("UPDATE")]),_vm._v(" "),_c('p',{staticClass:"all_p1"},[_vm._v("网站全面升级中...")]),_vm._v(" "),_c('p',{staticClass:"all_p2"},[_vm._v("国庆之后，敬请期待。")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ad2a23c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/canNotUse.vue
// module id = null
// module chunks = 